export default __webpack_public_path__ + "static/media/step_to_the_sun.6abb928f.svg";